import alt from 'components/Dispatcher';
import EnvSource from '@store/env/EnvSource';
import {Store} from '@store/@types/alt';
import EnvActions from './EnvActions';

interface EnvStoreState {}

class EnvStore extends Store<EnvStoreState> {
  constructor() {
    super();
    this.state = {};
    this.bindActions(EnvActions);
    this.registerAsync(EnvSource);
  }

  /**
   * EnvStore handlers
   */
  onGetEnv() {
    setImmediate(() => this.getInstance<typeof EnvSource>().get());

    this.preventDefault();
  }

  onEnvSuccess(response) {
    this.setState(response.data);
  }

  onEnvError(error) {
    console.log(error);
  }
}

export default alt.createStore(EnvStore);
